// extracted by mini-css-extract-plugin
export default {"circle":"f978c2244b086d3863e2"};